import React, {Suspense, useMemo, useState} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import DateUtil from "utils/DateUtil";
import CommonUtil from 'utils/CommonUtil';
import StringUtil from "utils/StringUtil";
import UIUtils from "utils/UIUtils";
import TbComFile from "domain/main/com/file/TbComFile";
import UI from "../../../../components/UI";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import UISunEditor from "../../../../components/wysiwygeditor/UISunEditor";
import PageLoading from "../../../../components/loading";
import use from "../../../../common/hooks/use";

function ContentsContainer() {
    const history = useHistory();

    const [tbAgree, setTbAgree] = React.useState<any[]>([
        {id: 1, text: '위 안내사항에 동의함을 확인합니다.', guide: '안내', checked: false},
        {id: 2, text: "수혜 대상자는 「중소기업 기본법」 제2조에 해당하는 '중소기업'을 확인합니다.", guide: '지원대상', checked: false},
        {
            id: 3,
            text: "「법인세법」및 「법인세법 시행령」에 따른 '특수관계인'에 해당하는 대상자는 지원 할 수 없음을 확인합니다.",
            guide: '지원대상',
            checked: false
        },
        {
            id: 4,
            text: '지원 내용이 「대·중소기업 상생협력 촉진에 관한 법률」제20조의5 및 동법 시행령 제13조의4에 따른 상생협력기금 사용 용도에 해당함을 확인합니다.',
            guide: '지원대상',
            checked: false
        },
        {id: 5, text: '지원의 결과물(지식재산권 등)에 대하여, 출연기업의 지분에 상생협력기금은 제외함을 확인합니다.', guide: '지원대상', checked: false},
        {id: 6, text: '지원 내용에 대하여 출연기업은 매입 계산서를 발행하지 않아야 하며, 매출로 계상할 수 없습니다.', guide: '지원대상', checked: false},
    ]);

    const [isAllChk, setIsAllChk] = useState(false);

    const thisYear = new Date().getFullYear();
    const contentObj = useMemo(() => CommonUtil.execute({
        url: 'usr_2100',
        data: {
            "TSK_ANN_YYYY": `${thisYear}`
        }
    }).then((result: any) => {
        console.log(result)

        const fileValue = new TbComFile();
        fileValue.setTbComFileMapngDetailList([]);

        let fileList = result.FILE_INFO;
        for (const fileInfo of fileList) {
            //파일등록 정보
            const fileDetail = new TbComFileMapngDetail();
            fileDetail.setDwldId(fileInfo.DWLD_ID);
            fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
            fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
            fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
            fileDetail.setStrePath(fileInfo.STRE_PATH);
            fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
            fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
            fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
            fileDetail.setFileSize(fileInfo.FILE_SIZE);
            fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
            fileDetail.setRegistDt(fileInfo.REGIST_DT);
            fileValue.putTbComFileMapngDetailList(fileDetail);
            // setFileSize(fileInfo.FILE_SIZE);
        }

        return {
            title: result.TSK_ANN_TITLE,
            cont: result.TSK_ANN_CONT,
            fileId: result.FILE_ID,
            fileValue: fileValue
        }
    }), [thisYear]);

    function isChecked(element) {
        if (element.checked == false) {
            return true;
        }
    }

    const checkBoxHandler = (e) => {

        let newList = [...tbAgree];

        if (e.target.id === 'ch-all') {
            setIsAllChk(e.target.checked);
        } else {
            newList[Number(e.target.id.replace('ch-t', '')) - 1].checked = e.target.checked;
        }

        if (e.target.id != 'ch-all') {
            let isAll = false;

            if (tbAgree.find(isChecked) == undefined) {
                isAll = true;
            }
            setIsAllChk(isAll);
            setTbAgree(newList);
        } else {
            let allCheckBol = e.target.checked;
            newList = newList.map(e => {
                e.checked = allCheckBol;
                return e;
            });
            setTbAgree(newList);
        }

    };

    const alertModal = async () => {
        const value = await UIUtils.alert(<>
            <span className="fc-pri">*</span> 전체동의가 필요합니다.
        </>);
    }

    function gotoTsk() {
        if (!isAllChk) {
            alertModal();
            return false;
        } else {
            //리스트 페이지로 이동
            // 다른 페이지로 이동하면서 데이터 전달
            history.push({
                pathname: './usr_2101'
            });
        }
    }

    // if(!loadFinish)
    // 	return (
    // 		<PageLoading />
    // 	)
    // else
    return (
        <PageContainer>
            <LayoutAside/>
            <div className='fww-con'>
                <Breadcrumb gnbIdx={2} lnbIdx={0}/>
                <main className="fww-main">
                    <Suspense fallback={<PageLoading/>}>
                        <ViewLazyContent contentObj={contentObj}/>
                    </Suspense>
                    <section className="fund-section">
                        <form name="" action="" method="" className="biz-agree-list">
                            <div className=" mb15">
                                <label htmlFor="ch-all" className="hz-item ip-ch-label ip-ch-18">
                                    <input id="ch-all" className="ip-ch" type="checkbox" checked={isAllChk}
                                           onChange={(e) => checkBoxHandler(e)}/>
                                    <span className="check"></span>
                                    <span className="txt">전체 동의</span>
                                </label>
                            </div>
                            <div className="tb tb-narrow">
                                <table data-type="file">
                                    <caption></caption>
                                    <colgroup>
                                        <col width="90px"/>
                                        <col/>
                                        <col width="230px"/>
                                    </colgroup>
                                    <tbody>
                                    {tbAgree.map((tbAgree, index) => (
                                        <tr key={index}>
                                            <td>
                                                <label htmlFor={"ch-t" + tbAgree.id}
                                                       className="hz-item ip-ch-label ip-ch-18">
                                                    <input id={"ch-t" + tbAgree.id} className="ip-ch" type="checkbox"
                                                           checked={tbAgree.checked}
                                                           onChange={(e) => checkBoxHandler(e)}/>
                                                    <span className="check"></span>
                                                </label>
                                            </td>
                                            <td className="ta-left">{tbAgree.text}</td>
                                            <td>{tbAgree.guide}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </form>
                    </section>
                    <div className="hz-root hz-right hz-gap10 mt30">
                        <Button color="pri" size="md" onClick={gotoTsk}>과제신청</Button>
                    </div>
                </main>
            </div>
        </PageContainer>
    );
}

export default ContentsContainer;

function ViewLazyContent({contentObj}: { contentObj: Promise<any> }) {
    const conntent = use(contentObj);
    return (
        <>
            <h1 className="tx tx-hd2">과제승인신청</h1>
            <div className="fund-biz-title">
                {conntent.title}
            </div>
            <section className="fund-section">
                <h3 className="section-title mb15">신청 안내</h3>
                <div className="fund-biz-preview">
                    <UISunEditor value={conntent.cont} displayOnly={true} readOnly={true} />
                </div>
            </section>
            <section className="fund-section">
                <h3 className="section-title mb15">첨부파일</h3>
                <form name="" action="" method="">
                    <div className="tb tb-narrow">
                        <UI.FileDownloadSimpleMode
                            value={conntent.fileValue}
                            rowNumber={true}
                            viewMode={"table"}/>
                    </div>
                </form>
            </section>
        </>
    )
}